import {
  FETCH_ALL_TRAININGS,
  CREATE_TRAININGS,
  DELETE_TRAININGS,
  UPDATE_TRAININGS,
} from '../constants/actionTypes';

const trainings = (trainings = [], action) => {
  switch (action.type) {
    case FETCH_ALL_TRAININGS:
      return action.payload;
    case CREATE_TRAININGS:
      return [...trainings, action.payload];
    case UPDATE_TRAININGS:
      return trainings.map((training) =>
        training._id === action.payload._id ? action.payload : training,
      );
    case DELETE_TRAININGS:
      return trainings.filter((training) => training._id !== action.payload);
    default:
      return trainings;
  }
};

export default trainings;
